import { lazy } from 'react'
import type { RouteObject } from 'react-router'
const PageDistribution = lazy(() =>
  import('./PageDistribution').then((m) => ({ default: m.PageDistribution })),
)
export const routesDistribution: RouteObject[] = [{ index: true, element: <PageDistribution /> }]
